import React, { useState } from "react";
import { Search } from "@vapor/react-icons/Search";
import Button from "@vapor/react-material/Button";
import { Drawer } from "@vapor/react-material/Drawer";
import { Box } from "@vapor/react-material/Box";
import { Card } from "@vapor/react-material/Card";
import { CardContent } from "@vapor/react-material/CardContent";
import Typography from "@vapor/react-extended/ExtendedTypography";
import TextField from "@vapor/react-material/TextField";
import { Chip } from "@vapor/react-material/Chip";
import { Stack } from "@vapor/react-material/Stack";
import { VaporIcon } from "@vapor/react-icons/VaporIcon";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faFolderArrowUp } from "@fortawesome/pro-regular-svg-icons";
import { faAnglesUpDown } from "@fortawesome/pro-solid-svg-icons";
import DataCard from "./DataCard.tsx";
import OrderPopover from "./OrderPopover.tsx";
import { chips } from "../../../../assets/DummyData.tsx";
import { useDrawerStore } from "../../../../context/DrawerContext/index.ts";
// import { useDrawerStore } from "../../../../context/DrawerContext/index.ts";

const PreferitiNotifications = ({ drawerName }) => {
  const { open, setOpen } = useDrawerStore();
  const [orderCard, setOrderCard] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [chipState, setChipState] = useState<string>("Tutti");

  const setSelectedChip = (selectedChip: string) => {
    setChipState(selectedChip);
  };

  const handleOrderClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    console.log("event", event.currentTarget);
    setOrderCard(true);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setOrderCard(false);
  };

  const handleDrawer = () => {
    setOpen(open === drawerName ? null : drawerName);
  };

  return (
    <div>
      <Button
        onClick={handleDrawer}
        sx={{
          "&:hover": {
            backgroundColor: "#008FD6",
          },
          backgroundColor: open === drawerName ? "#14A8E8" : "inherit",
        }}
      >
        <VaporIcon icon={faStar} color="inverse" />
      </Button>
      <Box>
        <Drawer
          anchor="right"
          open={open === drawerName}
          onClose={handleDrawer}
          // hideBackdrop
          width={500}
        >
          <Box marginTop="3rem">
            <CardContent>
              <Box display="flex" justifyContent="space-between">
                <Typography>Preferiti (25)</Typography>
                <Box display="flex" justifyContent="space-between">
                  <Button onClick={(event) => handleOrderClick(event)}>
                    <VaporIcon icon={faAnglesUpDown} color="interactive" />
                  </Button>
                  {orderCard && (
                    <OrderPopover
                      anchorEl={anchorEl}
                      onClose={handleClosePopover}
                    />
                  )}
                  <Button>
                    <VaporIcon icon={faFolderArrowUp} color="interactive" />
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Box>
          <Box>
            <Card
              sx={{
                height: 120,
              }}
            >
              <CardContent>
                <Stack alignItems="end" direction="row">
                  <TextField
                    id="outlined-textarea"
                    multiline
                    placeholder="Cerca tra  preferiti"
                    fullWidth
                  />
                  <Button variant="contained">
                    <Search />
                  </Button>
                </Stack>
                <Box>
                  <Stack
                    sx={{
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "0 !important ",
                      },
                    }}
                    direction="row"
                    spacing={1}
                    marginTop="12px"
                  >
                    {chips.map((chip) => (
                      <Chip
                        key={chip.index}
                        avatar={chip.icon}
                        label={chip.title}
                        clickable
                        variant={
                          chipState === chip.title ? "outlined" : "filled"
                        }
                        onClick={() => setSelectedChip(chip.title)}
                      />
                    ))}
                  </Stack>
                </Box>
              </CardContent>
            </Card>
            <Box
              sx={{
                backgroundColor: "#F5F5F5",
              }}
            >
              <Typography
                fontSize="14px"
                color="primary.interactiveDefault"
                marginLeft="18px"
              >
                Warehouse
              </Typography>
            </Box>
            <DataCard />
          </Box>
        </Drawer>
      </Box>
    </div>
  );
};

export default PreferitiNotifications;
